import { axiosGet } from "../../Helpers";

export const loadMajors = async (setLoading) => {
  setLoading(true);
  const response = await axiosGet("major/listMajor");
  setLoading(false);
  const data = response.data?.data;
  data.map((item, index) => {
    item.id = index + 1;
  });
  return data;
};
